import React from 'react';

/**
 * Component to make your code looks nice when you want to decide
 * whether child components should be rendered or not.
 *
 * @param children
 * @param visible
 * @returns {{children}}
 * @constructor
 */
const RenderCondition = ({ children, condition }) => condition && children;

export default RenderCondition;
